import { useEffect, useState } from 'react';

const useThemeColor = (colorName: string) => {
  const [color, setColor] = useState<string>('');

  useEffect(() => {
    const root = document.documentElement;
    const lightColor = getComputedStyle(root)
      .getPropertyValue(`--light-${colorName}`)
      .trim();
    const darkColor = getComputedStyle(root)
      .getPropertyValue(`--dark-${colorName}`)
      .trim();
    const highContrastColor = getComputedStyle(root)
      .getPropertyValue(`--highContrast-${colorName}`)
      .trim();

    const mediaQueryDark = window.matchMedia('(prefers-color-scheme: dark)');
    const mediaQueryHighContrast = window.matchMedia('(forced-colors: active)');

    const updateColor = () => {
      if (mediaQueryHighContrast.matches) {
        setColor(highContrastColor);
      } else if (mediaQueryDark.matches) {
        setColor(darkColor);
      } else {
        setColor(lightColor);
      }
    };

    updateColor();
    mediaQueryDark.addEventListener('change', updateColor);
    mediaQueryHighContrast.addEventListener('change', updateColor);

    return () => {
      mediaQueryDark.removeEventListener('change', updateColor);
      mediaQueryHighContrast.removeEventListener('change', updateColor);
    };
  }, [colorName]);

  return color;
};

export default useThemeColor;
